import { atom } from "jotai";

import { UpdateGuestRoundInput } from "../../../../../hooks/saveChangesHooks/useSaveChangesToSingleSlotBooking/__generated__/useSaveChangesToSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

const sanitizeGuestRateId = (rateId: string | null | undefined) => {
  if (!rateId) return rateId;
  return rateId.startsWith("MemberRate:") ? null : rateId;
};

export const updatedGuestRoundsAtom = atom<UpdateGuestRoundInput[] | null>(
  (get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const rounds = currentBooking.rounds;
    const guestRounds = rounds?.filter(
      (r) =>
        r.player?.clientType === "guest" ||
        r.player?.clientType === "unknownGuest"
    );
    const input: UpdateGuestRoundInput[] = guestRounds?.map((r) => ({
      index: r.index,
      bookingIndex: r.bookingIndex,
      id: r.serverId,
      playerId: r.player?.id || null,
      courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
      transportationTypeId: r.type === "Golf" ? r.transportationType?.id : null,
      secondaryTransportationTypeId: r.secondaryTransportationType?.id,
      rateId: sanitizeGuestRateId(
        r.type === "Golf" ? r.roundRate?.id : r.rate?.id ?? null
      ),
      manualPaymentStatus: r.manualPaymentStatus ?? "AUTO_CHARGE",
    }));
    return input;
  }
);
